import React, { useEffect, useState, useRef } from 'react'
import dayjs from 'dayjs';
import { Badge, Breadcrumb, Button, Calendar, DatePicker, Drawer, Flex, Form, Input, Layout, notification, Select, Skeleton, Steps, theme, Tooltip } from 'antd';
import { EVENTS, NOTES } from './style';
import './leavstyles.css';
import {
    UsergroupAddOutlined,
    SmileOutlined,
    HomeOutlined,
    AppstoreOutlined,
    LeftOutlined,
    RightOutlined,
    CalendarOutlined
} from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { screenStart, generalInformationCapture, committeeCapture, agendaCapture, screenEnded, actionStateCapture } from '../../../redux/slices/meetingSlice';
import MyEvents from './MyEvents';
import moment from 'moment-timezone';
import AgendaItem from './NewMeeting/AgendaItem';
import CommitteeInfo from './NewMeeting/CommitteeInfo';
import MasterDataAPI from '../../../restAPI/MasterDataAPI';
import CalendarDataAPI from '../../../restAPI/CalendarDataAPI'
// import GeneralInformation from './NewMeeting/GeneralInformation';
import GeneralInformation from '../../../helperComponents/CreateNewMeeting/GeneralInformation';
import NewMeetingDrawer from '../../../helperComponents/CreateNewMeeting/NewMeetingDrawer';
import { useNavigate } from 'react-router-dom';
import { COLOR } from '../../../theme/constant';
import CommonSkeletonLoader from '../../../helperComponents/CommonSkeleton';
import useCurrentCompany from '../../../hooks/useCurrentCompany';

const { Option } = Select;

const getMonthData = (value) => {
    if (value.month() === 8) {
        return 1394;
    }
};
const { Content } = Layout;

export default function MyCalendar() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { token: { colorBgContainer, borderRadiusLG, colorSuccess, colorTextDescription, colorWarning }, } = theme.useToken();
    const { companyId, token, role, userCompany } = useSelector(state => state.auth);

    const {
        generalInformation,
        committee,
        agendas,
        screenStarted,
        error
    } = useSelector(state => state.meeting);

    const [monthEventsList, setMonthEventsList] = useState([]);
    const [dayEventsList, setDayEventsList] = useState([]);
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
    const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
    const [eventsByMonth, setEventsByMonth] = useState([]);
    const [mode, setMode] = useState('month');
    const [meetingDrawerOpen, setMeetingDrawerOpen] = useState(false);
    const [selectedDate, setSelectedDate] = useState(null);
    const [selectedDateForMeeting, setSelectedDateForMeeting] = useState(null);
    const [committeeMembersList, setCommitteeMembersList] = useState([]);
    const [value, setValue] = useState(() => dayjs());
    const [tempDateValue, setTempDateValue] = useState(() => dayjs())

    const calendarRef = useRef(null);
    const [form] = Form.useForm();
    const generalInformationRef = useRef();
    const committeeInfoRef = useRef();
    const [isRecurring, setIsRecurring] = useState(false);
    const [selectedDays, setSelectedDays] = useState([]);
    const [value2, setValue2] = useState('on');
    const [isPrevClickedToGeneral, setIsPrevClickedToGeneral] = useState(false);
    const [isPrevClickedToCommittee, setIsPrevClickedToCommittee] = useState(false);
    const [startAndEndTimeGap, setStartAndEndTimeGap] = useState(30);
    const [open2, setOpen2] = useState(false);    
    const currentCompanyInfo = useCurrentCompany();
    const [isCurrentOrHigherDate, setIsCurrentOrHigherDate] = useState(false);
    const [tempMeetingList, setTempMeetingList] = useState(null)
    const [actionState, setActionState] = useState('add');
    const [singleDayListLoading, setSingleDayListLoading] = useState(false);
    const [monthDataLoading, setMonthDataLoading] = useState(false);

    const [api, contextHolder] = notification.useNotification();
    const openNotificationWithIcon = (type, message, description, placement) => {
        api[type]({
            message: message,
            description: description,
            placement
        });
    };

    const newMeetingItems = [
        {
            title: 'General Information', content: <GeneralInformation
                isRecurring={isRecurring}
                setValue2={setValue2}
                value2={value2}
                setIsRecurring={setIsRecurring}
                selectedDays={selectedDays}
                setSelectedDays={setSelectedDays}
                ref={generalInformationRef}
                isPrevClickedToGeneral={isPrevClickedToGeneral}
                selectedDateForMeeting={selectedDateForMeeting}
                setSelectedDateForMeeting={setSelectedDateForMeeting}
                open2={open2}
                startAndEndTimeGap={startAndEndTimeGap}
                setStartAndEndTimeGap={setStartAndEndTimeGap}
            />, icon: <AppstoreOutlined />
        },
        {
            title: 'Committee', content: <CommitteeInfo
                ref={committeeInfoRef}
                committeeMembersList={committeeMembersList}
                setCommitteeMembersList={setCommitteeMembersList}
                isPrevClickedToCommittee={isPrevClickedToCommittee}
            />, icon: <UsergroupAddOutlined />
        },
        { title: 'Agenda', content: <AgendaItem /> },
    ];

    
    const getMeetingsByDate = async () => {
        setSingleDayListLoading(true)
        try {
            const res = await CalendarDataAPI.getMeetingsByDate(selectedDate, companyId, token);
            if (res) {
                // console.log('meetings list :', res.data.data)
                setDayEventsList(res.data.data.length > 0 ? res.data.data : []);
                setTempMeetingList(res.data);
                setSingleDayListLoading(false)
            } else{
                setSingleDayListLoading(false)
                setDayEventsList([]);
                setTempMeetingList([]);
            }
        } catch (err) {
            setSingleDayListLoading(false)
            setDayEventsList([]);
            setTempMeetingList([]);
            console.log("Error in getMeetingsByMonth:", err);
        }
    };

    


    useEffect(() => {
        setMonthDataLoading(true);
        getMeetingsByMonth()
    }, [selectedYear, selectedMonth, companyId])

    useEffect(() => {
        if (selectedDate && meetingDrawerOpen) {
            getMeetingsByDate()
        }
    }, [selectedDate, companyId, meetingDrawerOpen])

    useEffect(() => {
        if (monthEventsList.length > 0) {
            // console.log('monthEventsList :', monthEventsList)
            const eventsByMonth = monthEventsList.reduce((acc, singleDay) => {
                const meetings = singleDay.todayData.meetings.map(singleMeeting => ({
                    date: moment(singleDay.date).format('YYYY-MM-DD'),
                    content: `${singleMeeting.info.name} • ${formatDateTime(singleMeeting.info.startDate)}`,
                    time: formatDateTime(singleMeeting.info.startDate),
                    name: singleMeeting.info.name,
                    // color: singleMeeting.status === 'unpublish' ? 'gray' : `${colorPrimary}`,
                    color: singleMeeting.status === 'unpublish' ? 'gray' : 
                        singleMeeting.status ==='held' ? colorWarning : 
                        singleMeeting.status === 'archive' ? COLOR.alizarin500 :
                        singleMeeting.status === 'minutes' ? COLOR.peterRiver500 : colorSuccess, 
                        // singleMeeting.status === 'publish' ? COLOR.peterRiver500 : ,
                    startTime: formatDateTime(singleMeeting.info.startDate),
                    leaveStatus: singleDay.todayData.leave.leaveStatus,
                    meetingStatus: true
                }));
            
                // Check if there's a leave record
                if (singleDay.todayData.leave.leaveStatus) {
                    const leaveRecord = {
                        date: moment(singleDay.date).format('YYYY-MM-DD'),
                        content: singleDay.todayData.leave.leaveType, // Example: "On Leave"
                        time: "",
                        name: singleDay.todayData.leave.name,
                        // color: "#ff4d4f", // Example: Red for leave
                        startTime: null,
                        leaveStatus: true,
                        meetingStatus: false
                    };
                    return acc.concat(meetings.length > 0 ? meetings : [leaveRecord]);
                }
            
                // Include days with meetings, even if no leave is present
                return acc.concat(meetings);
            }, []);
            
            setEventsByMonth(eventsByMonth);
        } else {
            setEventsByMonth([]);
        }
    }, [monthEventsList])

    useEffect(() => {
        if (selectedDate) {
            const selectedDateOnly = dayjs(selectedDate).startOf('day');
            const currentDateOnly = dayjs().startOf('day');

            if (selectedDateOnly.isBefore(currentDateOnly)) {
                setIsCurrentOrHigherDate(true);
            }
            else {
                setIsCurrentOrHigherDate(false);
            }
        }
    }, [selectedDate])

    useEffect(() => {
        if (calendarRef.current) {
            const existingHighlights = calendarRef.current.querySelectorAll('.calendar-leave');
            existingHighlights.forEach((element) => {
                element.classList.remove('calendar-leave');
            });
    

            if (eventsByMonth && eventsByMonth.length > 0) {
                const leaveElements = calendarRef.current.querySelectorAll('.leave');
                leaveElements.forEach((leaveElement) => {
                    const grandparent = leaveElement.parentElement?.parentElement?.parentElement;
                    if (grandparent) {
                        grandparent.classList.add('calendar-leave');
                    }
                });
            }
        }
    }, [eventsByMonth, companyId]); 

    function formatDateTime(dateTimeString) {
        const date = new Date(dateTimeString);
        let hours = date.getHours();
        const minutes = date.getMinutes();
        const ampm = hours >= 12 ? 'PM' : 'AM';

        hours = hours % 12;
        hours = hours ? hours : 12;
        const strMinutes = minutes < 10 ? '0' + minutes : minutes;

        return `${hours}:${strMinutes} ${ampm}`;
    }

    const getMeetingsByMonth = async () => {
        try {
            const res = await CalendarDataAPI.getMeetingsByMonth(selectedYear, selectedMonth, companyId, token);
            if (res && res.data) {
                // console.log('Calendar :', res.data)
                // add leaves for the calendar part.
                const daysInMonth = dayjs(`${selectedYear}-${selectedMonth}`).daysInMonth()
                const schedule = [];
                for (let day = 1; day <= daysInMonth; day++) {
                    const date = dayjs(`${selectedYear}-${selectedMonth}-${day}`)
                    // console.log('date :', date)
                    const dayMeetings = res.data.meetings.filter(singleMeeting => {
                        if (dayjs(singleMeeting.meetingDate).isSame(dayjs(date), "day")) {
                            const gotPermission = role.some(r => r.roleName === 'Secretary' || 'Assistant Secretary');
                            if (gotPermission) {
                                return true
                            } else {
                                return singleMeeting.status !== false
                            }
                        } else {
                            return false
                        }
                    })
                    const leaveDates = res.data.leaves.filter(singleLeaveDay => {
                        if (dayjs(singleLeaveDay.leaveDate).isSame(dayjs(date), "day")) {
                            return true
                        } else {
                            return false
                        }
                    })
                    schedule.push({
                        date: dayjs(date).toISOString(),
                        // date: dayjs(date).format(),
                        todayData: {
                            meetings: dayMeetings[0]?.meetings || [],
                            leave: {
                                leaveStatus: leaveDates.length > 0 ? true : false,
                                leaveType: leaveDates.length > 0 ? leaveDates[0]?.leaveType : null
                            }
                        },
                    })
                }
                // console.log("schedule :", schedule)
                // let filteredMeetings = res.data.meetings.map((monthData) => ({
                //     ...monthData,
                //     meetings: monthData.meetings.filter(meeting => {
                //         const gotPermission = role.some(r => r.roleName === 'Secretary' || 'Assistant Secretary');

                //         if (gotPermission) {
                //             return true;
                //         } else {
                //             return meeting.status !== false;
                //         }
                //     }),
                // }));
                // setMonthEventsList(filteredMeetings);
                setMonthEventsList(schedule);
                setMonthDataLoading(false);
            } else{
                setMonthDataLoading(false);
            }
        } catch (err) {
            setMonthEventsList([]);
            setMonthDataLoading(false);
            console.log("Error in getMeetingsByMonth:", err);
        }
    };

    const monthCellRender = (value) => {
        const num = getMonthData(value);
        return num ? (
            <div style={NOTES.month}>
                {/* <section style={NOTES.monthSection}>{num}</section> */}
                {/* <span>Backlog number</span> */}
            </div>
        ) : null;
    };
    const dateCellRender = (value) => {
        const dateString = value.format('YYYY-MM-DD');
        const listData = eventsByMonth.filter(event => event.date === dateString);
        return listData || [];
    };

    function convertTo24HourFormat(startTime) {
        const [time, modifier] = startTime.split(' ');
        let [hours, minutes] = time.split(':');
        hours = parseInt(hours, 10);

        if (modifier === 'PM' && hours !== 12) hours += 12;
        if (modifier === 'AM' && hours === 12) hours = 0;

        return `${hours.toString().padStart(2, '0')}:${minutes}`;
    }

    const cellRender = (current, info) => {
        if (info.type === 'date') {
            const listData = dateCellRender(current);
            if (listData.length > 0) {
                // Sort by start time
                listData.sort((a, b) =>
                    convertTo24HourFormat(a.startTime).localeCompare(convertTo24HourFormat(b.startTime))
                );
            }

            // Extract the first two meetings and calculate the count of hidden meetings
            const visibleMeetings = listData.slice(0, 2);
            const hiddenMeetingsCount = listData.length - visibleMeetings.length;

            return (
                <ul style={EVENTS.main}>
                    {/* Render the visible meetings */}
                    {visibleMeetings.map((item, index) => (
                        <li key={index} className={item.leaveStatus ? 'leave' : ''}>
                            <div
                                style={{
                                    ...EVENTS.view,
                                    backgroundColor: `${item.color}`,
                                    borderRadius: borderRadiusLG,
                                }}
                            >
                                <div style={EVENTS.itemName}>
                                    {item.name}
                                </div>
                                <div style={EVENTS.itemTime}>
                                    {item.time}
                                </div>
                            </div>
                        </li>
                    ))}

                    {/* Show 'Show more...' if there are hidden meetings */}
                    {hiddenMeetingsCount > 0 && (
                        <li>
                            <div
                                style={{
                                    ...EVENTS.view,
                                    color: colorTextDescription,
                                    textAlign: 'center',
                                    cursor: 'pointer',
                                    fontSize: 12
                                }}
                            >
                                {hiddenMeetingsCount} more...
                            </div>
                        </li>
                    )}
                </ul>
            );
        }

        if (info.type === 'month') {
            return monthCellRender(current);
        }

        return info.originNode;
    };


    // const showDrawer = () => {
    //     setMeetingDrawerOpen(true);
    // };
    const onClose = () => {
        getMeetingsByMonth();
        setMeetingDrawerOpen(false);
        setSelectedDateForMeeting(null);
        setDayEventsList([]);
    };

    const showDrawer2 = () => {
        setOpen2(true);
        dispatch(screenEnded())
        dispatch(actionStateCapture('add'));
    };
    const onClose2 = () => {
        if (generalInformationRef.current) {
            generalInformationRef.current.resetForm();
        }
        dispatch(screenEnded())
        getMeetingsByMonth();
        setCurrent(0);
        setIsRecurring(false);
        setIsPrevClickedToGeneral(false);
        setIsPrevClickedToCommittee(false);
        setSelectedDays([]);
        setValue2('on');
        setOpen2(false);
        setSelectedDateForMeeting(selectedDate);
        getMeetingsByDate();
    };
    const [conflictOpen, setConflictOpen] = useState(false);
    const showConflictDrawer = () => {
        setConflictOpen(true);
    };
    const onCloseConflictDrawer = () => {
        setConflictOpen(false);
    };

    const [selectedValue, setSelectedValue] = useState(() => dayjs());

    const onSelect = (newValue, selectMode) => {
        setValue(newValue);
        const currentDate = new Date();

        if (newValue.toISOString().split('T')[0] < currentDate.toISOString().split('T')[0]) {
            setIsCurrentOrHigherDate(true);
        }
        else {
            setIsCurrentOrHigherDate(false);
        }

        setSelectedValue(newValue);
        if (selectMode.source === 'date') {
            setMeetingDrawerOpen(true);
            // navigate(`/Meeting-management/Meetings?date=${newValue.format('YYYY-MM-DD')}`)
            setSelectedDate(newValue.format('YYYY-MM-DD HH:mm:ss'));
            // setSelectedDateForMeeting(newValue);
            form.setFieldsValue({ DatePicker: newValue });
        }
        if (selectMode.source === 'month') {
            setMode('month');
            setSelectedMonth(newValue.month() + 1);
        }
    };

    const onPanelChange = (newValue, newMode) => {
        setSelectedYear(newValue.year());
        setSelectedMonth(newValue.month() + 1);
        setMode(newMode);
    };

    const [current, setCurrent] = useState(0);

    const items = newMeetingItems.map((item) => ({
        key: item.title,
        title: item.title,
    }));

    const settingValues = async (screen) => {
        switch (screen) {
            case 0:
                try {
                    const values = await generalInformationRef.current.validateAndRetrieveData();
                    dispatch(screenStart());
                    const { meetingName, meetHeldAs, startDate, endDate, location, room, recurrence, repeatEvery, videoMethod } = values;

                    const formattedValues = {
                        info: {
                            name: meetingName
                        },
                        schedule: {
                            startDate: startDate.toISOString(),
                            endDate: endDate.toISOString()
                        },
                        held: {
                            type: meetHeldAs,
                            physical: {
                                location: meetHeldAs === 'physical' || meetHeldAs === 'hybrid' ? location : '',
                                room: meetHeldAs === 'physical' || meetHeldAs === 'hybrid' ? room : ''
                            },
                            online: meetHeldAs === 'online' || meetHeldAs === 'hybrid' ? videoMethod : ''
                        },
                        recurrence: {
                            status: isRecurring,
                            repeatEvery: isRecurring ? {
                                // occurrence: values.endDateAfterOccurrence,
                                occurrence: values.repeatEvery,
                                // occurrence: repeatEvery,
                                type: recurrence,
                                dayOfWeek: selectedDays
                            } : {},
                            repeatEnd: {
                                type: isRecurring ? value2 : 'on',
                                onDate: isRecurring && value2 === 'on' ? values.repeatEndOndDate.toISOString() : null,
                                afterOccurrence: isRecurring && value2 === 'after' ? values.endDateAfterOccurrence : null
                            }
                        }
                    };
                    dispatch(generalInformationCapture(formattedValues));
                } catch (error) {
                    console.error('Validation failed:', error);
                    return false;
                }
                break;
            case 1:
                try {
                    const values = await committeeInfoRef.current.validateAndRetrieveData();
                    dispatch(screenStart());
                    const { committeeType, committeeName } = values;

                    const formattedValues = {
                        participants: {
                            committeeType: committeeType,
                            committeeId: committeeName,
                            members: committeeMembersList,
                        },
                    }

                    dispatch(committeeCapture(formattedValues));
                } catch (error) {
                    console.log("Validation failed :", error);
                    return false;
                }
                // dispatch(committeeCapture({ "class": "12", "section": "B" }));
                break;
            case 2:
                dispatch(agendaCapture({ "hobby": "chess" }));
                break;
        }
        return true;
    };

    const next = async () => {
        const isValid = await settingValues(current);
        if (isValid) {
            setCurrent(current + 1);
            setIsPrevClickedToGeneral(false);
            setIsPrevClickedToCommittee(false)
        }
    };

    const prev = async () => {
        setCurrent(current - 1);
        setIsPrevClickedToGeneral(current === 1);
        setIsPrevClickedToCommittee(current === 2);
    };

    const finalSubmit = async () => {
        setCurrent(0);
        // Remove committeeType from generalInformation
        const { committeeType, ...filteredGeneralInformation } = generalInformation;

        // Create the payload
        const payload = {
            ...filteredGeneralInformation,
            ...committee,
            agendas,
            meetingStatus: "pending"
        };


        try {
            const response = await MasterDataAPI.createMeeting(payload, companyId, token);
            if (response.status === 200) {
                openNotificationWithIcon('success', 'Successful', `${response.data.message}`, 'bottomLeft');
                onClose2();
                getMeetingsByDate();
                dispatch(screenEnded());
            }
            else {
                openNotificationWithIcon('error', 'Failed', `Meeting creation failed.`, 'bottomLeft');
            }
        } catch (err) {
            openNotificationWithIcon('error', 'Failed', `Meeting creation failed.`, 'bottomLeft');
            console.error('Error:', err);
        }
    }

    const handleDateChange = (date) => {
        const formatted = date ? date.format('YYYY-MM-DD HH:mm:ss') : null;
        setSelectedDate(formatted);
        setSelectedDateForMeeting(formatted)
    };

    const renderCustomSkeleton = () => {
        const cells = [];
        for (let i = 0; i < 28; i++) {
            cells.push(
                <div
                key={i}
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    minWidth: 80,
                    gap: 1,
                    margin: '16px',
                    // padding: 24,
                }}
                >
                <Skeleton
                    avatar={{ shape: "square" }} // Set avatar shape to square
                    active
                    paragraph={false}
                    title={false}
                />
                <Skeleton active paragraph={{ rows: 2 }} title={false} />
                </div>
            );
        }

        return (
            <div
                style={{
                display: "grid",
                gridTemplateColumns: "repeat(7, 1fr)",
                gridTemplateRows: "repeat(4, 1fr)",
                gap: 10,
                padding: 4,
                borderRadius: 4,
                width: "100%",
                boxSizing: "border-box",
                }}
            >
                {cells}
            </div>
        );
    };

    return (
        <>
            <Flex gap={20} justify='space-between' align='center' style={{
                margin: '16px',
                padding: '16px 24px',
                // minHeight: 280,
                background: colorBgContainer,
                borderRadius: borderRadiusLG,
            }}>
                <Breadcrumb
                    items={[
                        {
                            // href: '',
                            title: <HomeOutlined />,
                        },
                        {
                            title: 'Meeting Management / My Calendar',
                        },
                    ]}
                />
                {/* <Flex justify='center' align='center' gap={48}>
                    <Button type="primary" onClick={showDrawer} >Add New</Button>
                </Flex> */}

            </Flex>
            {
                monthDataLoading ? (renderCustomSkeleton()) : (
                    <div 
                    ref={calendarRef}
                    style={{
                        margin: '16px',
                        padding: 24,
                        background: colorBgContainer,
                        borderRadius: borderRadiusLG,
                    }}>
                        <Calendar
                            cellRender={cellRender}
                            value={value}
                            onSelect={onSelect}
                            onPanelChange={onPanelChange}
                            mode={mode}
                            headerRender={({ value, onChange }) => {
                                const year = value.year();
                                const month = value.month();

                                return (
                                    <Flex align='center' justify='space-between'>
                                        <Flex align='center' justify='flex-start' gap={20}>
                                            <Select
                                                value={year}
                                                onChange={(newYear) => {
                                                    onChange(value.clone().year(newYear));
                                                }}
                                                style={{ width: 100 }}
                                            >
                                                {Array.from({ length: 30 }, (_, i) => (
                                                    <Option key={i} value={year - 15 + i}>
                                                        {year - 15 + i}
                                                    </Option>
                                                ))}
                                            </Select>
                                            <Select
                                                value={month}
                                                onChange={(newMonth) => {
                                                    onChange(value.clone().month(newMonth));
                                                }}
                                                style={{ width: 120 }}
                                            >
                                                {Array.from({ length: 12 }, (_, i) => (
                                                    <Option key={i} value={i}>
                                                        {value.clone().month(i).format('MMMM')}
                                                    </Option>
                                                ))}
                                            </Select>

                                        </Flex>
                                        <Flex align='center' justify='flex-end' gap={20}>
                                            <Button
                                                onClick={() => {
                                                    const tempTodayValue = dayjs().startOf('day');
                                                    onChange(tempTodayValue)
                                                }}
                                            >
                                                Today
                                            </Button>
                                            <Button
                                                icon={<LeftOutlined style={{ paddingLeft: 8, paddingRight: 8 }} />}
                                                onClick={() => {
                                                    const newValue = value.clone().subtract(1, 'month')
                                                    onChange(newValue)
                                                }}
                                            />
                                            <Button
                                                icon={<RightOutlined style={{ paddingLeft: 8, paddingRight: 8 }} />}
                                                onClick={() => {
                                                    const newValue = value.clone().add(1, 'month')
                                                    onChange(newValue)
                                                }}
                                            />
                                        </Flex>
                                    </Flex>
                                );
                            }}
                        />

                        {/* removed, because of enhancement No 9875 */}
                        <Drawer title="Meetings"
                         size='large'
                            onClose={onClose}
                            open={meetingDrawerOpen}
                            // extra={
                            //     <Flex justify='center' align='center' gap={20}>
                            //         {(role.some(r => r.roleName === "Secretary") || role.some(r => r.roleName === "Assistant Secretary")) && (
                            //             <Button disabled={isCurrentOrHigherDate} type="primary" onClick={showDrawer2}>
                            //                 Add Meeting
                            //             </Button>
                            //         )}
                            //     </Flex>
                            // }
                        >
                            <Form form={form}>
                                    <div style={{marginBottom:'18px',fontWeight:700,}}><CalendarOutlined /> {selectedDate && selectedDate.split(" ")[0]}</div>
                                {/* <Form.Item name="DatePicker">
                                    <DatePicker
                                        showTime
                                        style={{ width: '100%' }}
                                        value={selectedDate}
                                        onChange={handleDateChange}
                                        format="YYYY-MM-DD"
                                    />
                                </Form.Item> */}
                            </Form>
                            {singleDayListLoading ? <CommonSkeletonLoader itemCount={3}/> : (
                                dayEventsList.length !== 0 ? (
                                    dayEventsList.map((singleDay) => (
                                        singleDay.meetings
                                            .sort((a, b) => new Date(a.info.startDate) - new Date(b.info.startDate))
                                            .map((singleMeeting, index) => (
                                                <MyEvents
                                                    key={index}
                                                    name={singleMeeting?.info ? singleMeeting?.info?.name : "No meeting data"}
                                                    date={dayjs(selectedDate).format("YYYY-MM-DD")}
                                                    time={singleMeeting?.info ? `${formatDateTime(singleMeeting.info.startDate)} - ${formatDateTime(singleMeeting.info.endDate)}` : "No meeting data"}
                                                    company='default'
                                                    status={singleMeeting?.participant ? singleMeeting?.participant?.member.attendance === "mandatory" ? "Yes" : singleMeeting?.participant?.member.rsvp == 'Default' ? "RSVP" : singleMeeting?.participant?.member.rsvp : 'RSVP'}
                                                    meetingStatus={singleMeeting.status}
                                                    meetingDate={selectedDate}
                                                    setSelectedDate={setSelectedDate}
                                                    originalDate={singleMeeting.originalDate}
                                                    committeeId={singleMeeting.committeeId}
                                                    meetingId={singleMeeting._id}
                                                    meetingFullData={singleMeeting}
                                                    getMeetingsByDate={getMeetingsByDate}
                                                />
                                            ))
                                    ))
                                ) : (
                                    <>
                                        <Content >
                                            <span>No meetings scheduled for {selectedDate ? new Date(selectedDate).toLocaleDateString() : null}</span>
                                        </Content>
                                    </>
                                )
                            )}
                        </Drawer>

                        <Drawer title='Add New Meeting'
                            onClose={() => {
                                setStartAndEndTimeGap(30);
                                onClose2();
                            }}
                            open={open2}
                            size='large'
                            footer={[
                                <Flex justify='flex-end' align='center' gap='large'>
                                    {current > 0 && (
                                        <Button onClick={prev}>
                                            Previous
                                        </Button>
                                    )}
                                    {current < newMeetingItems.length - 1 && (
                                        <Button type="primary" onClick={next}>
                                            Next
                                        </Button>
                                    )}
                                    {current === newMeetingItems.length - 1 && (
                                        <Button type="primary" onClick={finalSubmit}>
                                            Done
                                        </Button>
                                    )}
                                </Flex>
                            ]}
                        >
                            <Content>
                                <Steps size="small" current={current} items={items} />
                                <div style={{ marginTop: 24 }}>{newMeetingItems[current].content}</div>
                            </Content>
                        </Drawer>
                        <Drawer title='Schedule Conflict Alert'
                            // onClose={onCloseConflictDrawer}
                            // open={showConflictDrawer}
                            size='large'
                            placement='left'
                            footer={[
                                <Flex justify='flex-end' align='center' gap='large'>
                                    <Button>
                                        Cancel
                                    </Button>
                                    <Button type="primary">
                                        Modify
                                    </Button>
                                    <Button type="primary">
                                        Accept
                                    </Button>
                                </Flex>
                            ]
                            }

                        >
                            {/* <Content>
                                <ConflictManagement />
                            </Content> */}
                        </Drawer>
                        {/* </Spin> */}
                        <NewMeetingDrawer
                            openDrawer={open2}
                            closeDrawer={onClose2}
                            selectedDate={selectedDate}
                            setSelectedDate={setSelectedDate}
                            isRecurring={isRecurring}
                            setIsRecurring={setIsRecurring}
                            selectedDays={selectedDays}
                            setSelectedDays={setSelectedDays}
                            value2={value2}
                            setValue2={setValue2}
                            current={current}
                            setCurrent={setCurrent}
                            isPrevClickedToGeneral={isPrevClickedToGeneral}
                            isPrevClickedToCommittee={isPrevClickedToCommittee}
                            setIsPrevClickedToGeneral={setIsPrevClickedToGeneral}
                            setIsPrevClickedToCommittee={setIsPrevClickedToCommittee}
                            actionState={actionState}
                            setActionState={setActionState}
                        />
                    </div>
                )
            }
            {contextHolder}
        </>
    )
}
